import { baseRoute } from '../../../constants/routes';

export const REGISTRATION_ROUTE = baseRoute + '/player-register-before';
export const REGISTRATION_ROUTE_AFTER = baseRoute + '/player-register-after';
export const REGISTRATION_ROUTE_AFTER_HATCH = baseRoute + '/player-register-after-hatch';
export const EXISTING_USER_CHECK_ROUTE = baseRoute + '/get-player-by-email';

export const SEND_REGISTRATION = 'SEND_REGISTRATION';
export const SEND_REGISTRATION_SUCCESS = 'SEND_REGISTRATION_SUCCESS';

export const SEND_REGISTRATION_AFTER = 'SEND_REGISTRATION_AFTER';
export const SEND_REGISTRATION_AFTER_SUCCESS = 'SEND_REGISTRATION_AFTER_SUCCESS';

export const SEND_REGISTRATION_AFTER_HATCH = 'SEND_REGISTRATION_AFTER_HATCH';
export const SEND_REGISTRATION_AFTER_HATCH_SUCCESS = 'SEND_REGISTRATION_AFTER_HATCH_SUCCESS';
